// FootlerWrapper.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import translations from "../../../../utils/language/translations.json";

import "./style.scss";

import logo from "../../../static/img/logo.png";
import facebookIcon from "../../icons/facebook.svg";
import instagramIcon from "../../icons/instagram.svg";

const FootlerWrapper = () => {
  // i18n – reuse the same namespace/keys as your old Footer
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.Footer[key]?.[currentLang] ?? key;

  const year = new Date().getFullYear();

  return (
    <footer className="footler footler__grid">
      {/* Brand / about (left column) */}
      <div className="footler__brand">
        <Link className="footler__logo" to="/" aria-label="CardsFolio home">
          <img src={logo} alt="CardsFolio" loading="lazy" decoding="async" />
        </Link>

        <div className="footler__social" aria-label="Social links">
          <div className="social-icons">
            <a
              href="https://www.facebook.com/CardsFolio"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="CardsFolio on Facebook"
              className="footler__icon footler__icon--fb"
            >
              <img src={facebookIcon} alt="Facebook" />
            </a>
            <a
              href="https://www.instagram.com/CardsFolio"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="CardsFolio on Instagram"
              className="footler__icon footler__icon--ig"
            >
              <img src={instagramIcon} alt="Instagram" />
            </a>
          </div>
        </div>

        <p className="footler__fineprint">
          © {year} CardsFolio. {t("AllRightsReserved") || "All rights reserved."}
          <br />
          {t("Tagline") ||
            "The platform to view, sell, and trade collectible cards."}
          <br />
          <br />
          {(t("HaveQuestions") || "Have questions?")}{" "}
          <a href="mailto:support@cardsfolio.ca">support@cardsfolio.ca</a>
        </p>
      </div>

      {/* Nav columns */}
      <nav className="footler__col" aria-label="Quick Links">
        <h4>{t("QuickLinks")}</h4>
        <ul>
          <li><Link to="/AboutUs">{t("AboutUs")}</Link></li>
          <li><Link to="/FAQ">{t("FAQ")}</Link></li>
        </ul>
      </nav>

      <nav className="footler__col" aria-label="Collectors">
        <h4>{t("Collectors")}</h4>
        <ul>
          <li><Link to="/trading-rules">{t("TradingRules")}</Link></li>
          <li><Link to="/shipping">{t("ShippingInfo")}</Link></li>
          <li><Link to="/payments">{t("PaymentMethods")}</Link></li>
          <li><Link to="/security">{t("SecurityMeasures")}</Link></li>
        </ul>
      </nav>

      <nav className="footler__col" aria-label="About CardsFolio">
        <h4>{t("AboutCardsFolio")}</h4>
        <ul>
          <li><Link to="/mission">{t("OurMission")}</Link></li>
          <li><Link to="/blog">{t("BlogNews")}</Link></li>
        </ul>
      </nav>

      <nav className="footler__col" aria-label="Legal">
        <h4>{t("Legal")}</h4>
        <ul>
          <li><Link to="/terms">{t("Terms")}</Link></li>
          <li><Link to="/privacy">{t("Privacy")}</Link></li>
        </ul>
      </nav>
    </footer>
  );
};

export default FootlerWrapper;
